import type { ReactNode } from 'react';

interface SkeletonRegionProps {
  /** What is loading, e.g. "Loading users" — read out by screen readers, and how specs find the skeleton. */
  label: string;
  className?: string;
  children: ReactNode;
}

/** The one accessible wrapper every skeleton renders inside: a busy status region, so the placeholder bars themselves stay silent. */
export function SkeletonRegion({ label, className, children }: SkeletonRegionProps) {
  return (
    <div role="status" aria-busy="true" aria-label={label} className={className}>
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
}
